'use client'
import { useState } from "react";
import { convertToSlug } from "./utils";
import author from "@/data/blogauthors.json"

const BlogListLayout = ({ posts }: { posts: Array<any> }) => {
  const [visiblePosts, setVisiblePosts] = useState(9);

  const handleShowMore = () => {
    setVisiblePosts((prev) => prev + 9); // Increase by 9 posts when "Show More" is clicked
  };

  const formatCustomDate = (dateStr) => {
    // Match DD-MM-YYYY HH:mm:ss
    const match = dateStr.match(/(\d{2})-(\d{2})-(\d{4})(?:[ T](\d{2}):(\d{2}):(\d{2}))?/);
    if (!match) return dateStr;
    const [, dd, mm, yyyy, hh = '00', min = '00', ss = '00'] = match;
    const date = new Date(`${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};
  return (
    <>
      {/* Blog Grid */}
      <div className="row gx-5 mt-n50 mt-sm-n30 mb-50 mb-sm-30 p-4 ">
        {posts.slice(0, visiblePosts).map((post, i) => {
          const matchedAuthor = author.find((authorObj) => authorObj.slug === post.frontMatter.author);

          return (
            <div
              key={post.slug}
              className="post-prev-2 col-md-6 col-lg-4 mt-50 p-3 rounded-lg border-2 border-gray-200 hover:border-gray-500 mt-sm-30 transform scale-95 transition-transform duration-300 ease-in-out hover:scale-100 hover:shadow-lg"
            >
              <div className="p-2 rounded-lg">
                <div className="post-prev-2-img mb-2">
                  <a href={`/blog/${post.slug}/`}>
                    <img loading="lazy" decoding="async"
                      src={post.frontMatter.og_image}
                      width={700}
                      height={350}
                      className="rounded-lg border border-black"
                      alt={post.frontMatter.page_title}
                    />
                  </a>
                </div>
                <div className="p-2 ">
                  {post.frontMatter.tags && post.frontMatter.tags.length > 0 && post.frontMatter.tags.slice(0, 2).map((tag, index) => (
                    <a key={index} href={`/blog/tags/${convertToSlug(tag)}/`} className="!text-black" >
                      <span className="border border-black p-1 rounded-lg mr-2 cursor-pointer hover:bg-gray-200">
                        {tag}
                      </span>
                    </a>
                  ))}

                  <h3 className="post-prev-2-title blog__title mt-2">
                    <a href={`/blog/${post.slug}/`} className="!text-gray-800 line-clamp-2">
                      {post.frontMatter.page_title}
                    </a>
                  </h3>

                  <div className="post-prev-2-info flex justify-between items-center">
                    <div className="blog__detail-meta flex items-center">
                      <a href={matchedAuthor?.href || '/'} className="flex-shrink-0">
                        <img loading="lazy" decoding="async"
                          className="rounded-full h-9 w-9"
                          src={matchedAuthor?.profile_image}
                          alt={matchedAuthor?.displayName}
                        />
                      </a>

                      <div className="flex-1 text-center">
                        <a href={matchedAuthor?.href || '/'} className="text-black">
                          <p>
                            <span>{matchedAuthor?.displayName}</span>
                          </p>
                        </a>
                      </div>
                    </div>

                    <span>{formatCustomDate(post.frontMatter.created_at)} 
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {visiblePosts < posts.length && (
        <div className="text-center mb-10">
          <button
            onClick={handleShowMore}
            className="px-6 py-3 bg-black text-white hover:bg-white hover:text-black border border-black rounded transition-colors duration-300"
          >
            Show More
          </button>
        </div>
      )}
    </>
  );
};

export default BlogListLayout;
